﻿import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import Form from '../../../../vendor/react-validation/components/form';
import ValidationButton from '../../../Forms/Components/ValidationButton';
import TextInput from '../../../Forms/Components/TextInput';

import getFormValues from '../../../Forms/getFormValues';
import { validEmail, mustBeEqual, validSwedishMobileNumber, validSwedishPhoneNumber} from '../../../Forms/Validation/rules';
import {InputHeading} from '../../../Forms/FormStyles/formStyles';
import {submitProfileFormAction} from '../State/actions';

class ProfileForm extends React.Component {
    submitForm = (e) => {
        e.preventDefault();
        this.props.submitProfileForm(getFormValues(this.form));
    }

    render() {
        const currentEmail = this.props.data.memberInfo.emailAddress
            ? this.props.data.memberInfo.emailAddress
            : 'mail@mail.se';

        const currentMobileNumber = this.props.data.memberInfo.mobilePhone;
        const currentPhoneNumber = this.props.data.memberInfo.homePhone;

        return (
            <Form ref={el => { this.form = el; }} onSubmit={e => this.submitForm(e)}>
                <FormRow noBorder>
                    <InputHeading>Telefonnummer</InputHeading>
                    <TextInput
                        id="mobilePhone"
                        name="mobilePhone"
                        placeholder={currentMobileNumber}
                        data-validation-error-message="Ange ett svenskt mobilnummer"
                        validations={[
                            validSwedishMobileNumber,
                        ]}
                    />
                </FormRow>
                <FormRow noBorder>
                    <InputHeading>Ny e-post</InputHeading>
                    <TextInput
                        id="emailAddress"
                        name="emailAddress"
                        placeholder={currentEmail}
                        data-validation-error-message="Ange en korrekt e-post"
                        validations={[
                            validEmail,
                            mustBeEqual('emailAddress', 'emailAddressConfirmation')
                        ]}
                    />
                </FormRow>
                <FormRow noBorder>
                    <InputHeading>Bekräfta ny e-post</InputHeading>
                    <TextInput
                        id="emailAddressConfirmation"
                        name="emailAddressConfirmation"
                        placeholder={currentEmail}
                        data-validation-error-message="Ange en korrekt e-post"
                        validations={[
                            validEmail,
                            mustBeEqual('emailAddress', 'emailAddressConfirmation', 'E-postadresserna stämmer inte överens')
                        ]}
                    />

                    <ValidationButton>
                        Spara
                    </ValidationButton>
                </FormRow>
            </Form>
        );
    }
}

// state

const mapStateToProps = (state) => {
    return {
        data: state.profilePageData,
        hasErrored: state.pageHasErrored,
        error: state.pageError,
        isLoading: state.pageIsLoading
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        submitProfileForm: (data) => dispatch(submitProfileFormAction(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileForm);

// styles
export const FormRow = styled.div`
    position: relative;
    margin-top: 30px;
`;